import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";

const GymSlugListings = ({ isPage, setIsPage, pageLimit, setPageLimit }) => {
  const { nearestGymsLoading, nearestGymsError, nearestGyms } = useSelector(
    (state) => state.webApi
  );

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (
      !nearestGymsLoading &&
      !nearestGymsError &&
      nearestGyms?.status &&
      nearestGyms?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: nearestGyms.data,
        pagination:
          nearestGyms?.pagination?.length > 0 ? nearestGyms.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [nearestGymsLoading, nearestGymsError, nearestGyms]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{ display: "block", textAlign: "start" }}>
            {row?.gym_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "slug",
      text: "Landing Page URL",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data icon"
            style={{ textDecoration: "underline", textTransform: "lowercase" }}>
            {row?.slug ? (
              <a
                className=""
                rel="noreferrer"
                target="_blank"
                href={`https://wtfgyms.com/lp/gym_lp_sale/${row?.slug}`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-box-arrow-up-right"
                  viewBox="0 0 16 16">
                  <path
                    fillRule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                  />
                  <path
                    fillRule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                  />
                </svg>
              </a>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
      {nearestGymsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default GymSlugListings;
